import React, { Fragment, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  useMsal,
  useAccount,
} from "@azure/msal-react";
import axios from "axios";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";

import MenuItem from "@mui/material/MenuItem";
import JSI from "./JSI_logo_blue.png";
import TrackNowLogo from "./TrackNow_logo_gradient.png";

import { Link } from "react-router-dom";
import AuthContext from "../../context/auth/AuthContext";
import CustomerContext from "../../context/customer/CustomerContext";
import CustomDialog from "../common/CustomDialog";
import type { IUser } from "../../types/Auth";
import { Badge } from "@mui/material";

import { TrackNowButton } from "../ui";
import { NavItem } from "./NavItem";
import { NavDropdown } from "./NavDropdown";
import { GoogleMaterialIcon } from '../ui/GoogleMaterialIcon';
import { alpha } from "@mui/material/styles";
import { tokens, useActiveBranding } from "../../theme/tokens";
import { useCommonDetailsContext } from "../../context/Common/common";
import usePermission from "../../usePermission";
import JSI360 from "./logo360.png";


const pages = ["Notifications", "Logout"];
interface UserInfo {
  userPrincipalName: string;
}

function NavBar() {
  const { accounts, instance } = useMsal();
  const { publishedBranding, setIsPublishedBranding, isBrandingLoaded, setIsBrandingLoaded, refreshUserRoleAndBranding, validateParentData } = useCommonDetailsContext();
  const activeBranding = useActiveBranding();
  const primaryColor = activeBranding?.primaryColor || tokens.colors.connectedPurple;
  const brandLogoSrc =
    typeof activeBranding?.logoDataUrl === "string" && activeBranding.logoDataUrl.trim()
      ? activeBranding.logoDataUrl
      : JSI;
  const account = useAccount(accounts[0] || {});
  const [name, setName] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);
  const [anchorElNav, setAnchorElNav] = useState<null | HTMLElement>(null);
  const [dropdownAnchor, setDropdownAnchor] = useState<HTMLElement | null>(null);

  const viewDetailsRef = React.useRef<HTMLDivElement>(null);
  const workflowsRef = React.useRef<HTMLDivElement>(null);
  const configurationsRef = React.useRef<HTMLDivElement>(null);

  const [openViewDetails, setOpenViewDetails] = useState(false);
  const [openConfigurations, setOpenConfigurations] = useState(false);
  const [openWorkflows, setOpenWorkflows] = useState(false);

  const authContext = useContext(AuthContext);
  const customerContext = useContext(CustomerContext);
  const { setCurrentCustomer } = customerContext;
  const {
    setAuthorized,
    authUser,
    setAuthStatus,
    setAuthUser,
    getUserRoles,
    setPermission,
    setNotificationCount,
    notificationCount,
    getCustomerNotifications,
    getFilingNotifications,
    getAllNotificationCount,
    getCustomerNotificationsWorkFlow,
    isPortalAuthenticated,
    portalUser,
    logout,
    token,
  } = authContext;
  const navigate = useNavigate();
  const { roleType, roleDetails } = authContext;
  const canViewHome = usePermission("ClientProfile", "viewPage");
  const canShowTrackNowMasterList = usePermission("MasterFilingList", "showMenu");
  const canViewTrackNowMasterList = usePermission("MasterFilingList", "viewPage");
  const canShowTrackNowDeferredList = usePermission("DefferedList", "showMenu");
  const canViewTrackNowDeferredList = usePermission("DefferedList", "viewPage");
  const canViewPostAwardMasterList = usePermission("PostAwardMasterList", "viewPage");
  const canShowPostAwardDeferredList = usePermission("PostAwardDefferedList", "showMenu");
  const canViewPostAwardDeferredList = usePermission("PostAwardDefferedList", "viewPage");
  const canViewClientTracker = usePermission("ViewClientFilingTracker", "viewPage");
  const canShowAddNewClient = usePermission("AddNewClient", "showMenu");
  const canShowAddTrackNowFiling = usePermission("AddFilingMaster", "showMenu");
  const canViewAddTrackNowFiling = usePermission("AddFilingMaster", "viewPage");
  const canShowTrackNowFilingMasterApproval = usePermission("FilingMasterApproval", "showMenu");
  const canViewTrackNowFilingMasterApproval = usePermission("FilingMasterApproval", "viewPage");
  const canShowTrackNowClientFilingMasterApproval = usePermission("ClientFilingMasterApproval", "showMenu");
  const canViewTrackNowClientFilingMasterApproval = usePermission("ClientFilingMasterApproval", "viewPage");
  const canShowAddPostAwardMaster = usePermission("AddPostAwardMaster", "showMenu");
  const canViewAddPostAwardMaster = usePermission("AddPostAwardMaster", "viewPage");
  const canShowPostAwardMasterApproval = usePermission("PostAwardMasterApproval", "showMenu");
  const canViewPostAwardMasterApproval = usePermission("PostAwardMasterApproval", "viewPage");
  const canShowPostAwardClientApproval = usePermission("PostAwardClientApproval", "showMenu");
  const canViewPostAwardClientApproval = usePermission("PostAwardClientApproval", "viewPage");
  const canShowBusinessCategory = usePermission("BusinessCategory", "showMenu");
  const canViewBusinessCategory = usePermission("BusinessCategory", "viewPage");
  const canShowApprovalConfiguration = usePermission("ApprovalConfiguration", "showMenu");
  const canViewApprovalConfiguration = usePermission("ApprovalConfiguration", "viewPage");
  const canShowProgramNames = usePermission("ProgramNames", "showMenu");
  const canViewProgramNames = usePermission("ProgramNames", "viewPage");
  const canShowPostAwardApprovalConfiguration = usePermission("PostAwardApprovalConfiguration", "showMenu");
  const canViewPostAwardApprovalConfiguration = usePermission("PostAwardApprovalConfiguration", "viewPage");
  const canViewSetting = usePermission("setting", "viewPage");
  const canViewUserRole = usePermission("userRole", "viewPage");
  const isAdmin = Array.isArray(roleType) ? roleType.includes("Admin") : false;
  const isAdminPostaward = Array.isArray(roleType)
    ? roleType.includes("Admin-PostAward")
    : false;
  const isBrandingRoleIncludes = Array.isArray(roleType)
    ? roleType.some((role: string) =>
      [
        "Admin",
        "Admin-PostAward",
        "ClientAdmin",
        "ClientAdmin-PostAward",
        "HierarchyAdmin",
        "HierarchyAdmin-PostAward",
      ].includes(role)
    )
    : roleType
      ? [
        "Admin",
        "Admin-PostAward",
        "ClientAdmin",
        "ClientAdmin-PostAward",
        "HierarchyAdmin",
        "HierarchyAdmin-PostAward",
      ].includes(roleType)
      : false;
  const hasParentCustomerTypeForBrandAdmin = Array.isArray(roleDetails) && roleDetails.some(
    (item: any) =>
      [
        "ClientAdmin",
        "ClientAdmin-PostAward",
        "HierarchyAdmin",
        "HierarchyAdmin-PostAward",
      ].includes(item?.roleName) &&
      (item?.customerType?.toLowerCase() === "parent" || item?.clientType?.toLowerCase() === "parent")
  );
  const isSingleParent = Boolean(validateParentData?.isSingleParent ?? validateParentData?.ifSingleParent);
  const showBrandingPage = Boolean(
    (roleType && (roleType.includes("Admin") || roleType.includes("Admin-PostAward"))) ||
    (isBrandingRoleIncludes && hasParentCustomerTypeForBrandAdmin)
  );
  console.log("roleDetails", roleDetails, "roleType", roleType, "isBrandingRoleIncludes", isBrandingRoleIncludes, "showBrandingPage", showBrandingPage);
  const handleLogout = (e?: any) => {
    if (e) e.preventDefault();
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    axios.get("/logout", config).then((response) => {
      // console.log("LOGGED OUT", response);
      if (logout) {
        logout();
        navigate("/");
      }
    });
    localStorage.removeItem("isAuthenticated");
    // logout();
  };

  const handleLogin = (e: any) => {
    window.location.href = "/login";
    // const config = {
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    // };
    // axios.get("/logout", config).then((response) => {
    //   console.log("APPS", response);
    //   history.push("/");
    // });
    // login();
  };

  const fetchUserRole = async () => {
    if (getUserRoles) await getUserRoles();
  };

  useEffect(() => {
    // console.log("Init Base URL:", process.env.REACT_APP_TRKNW_API_BASE_URL);
    fetchUserRole();
  }, []);

  useEffect(() => {
    if (authUser && authUser.loginId) {
      setName(authUser.loginId);
      // console.log("USER ACCOUNT2:", authUser);
      // getUserRole(response1);
    } else {
      setName("");
    }
  }, [authUser]);

  const getUserRole = async (userRole: any) => {
    if (refreshUserRoleAndBranding) {
      await refreshUserRoleAndBranding(userRole);
    }
  };

  const findRole = (ele: any) => {
    return ele.loginId.toLowerCase() === portalUser?.email?.toLowerCase();
  };

  const closeAlert = () => {
    setShowAlert(false);
    instance.logoutRedirect({
      postLogoutRedirectUri: "/",
    });
  };

  useEffect(() => {
    if (isPortalAuthenticated) {
      // console.log("USER AUTH ACCOUNT:", portalUser);
      getUserRole(portalUser);
    }
  }, [isPortalAuthenticated, portalUser]);

  const [customerNotificationCount, setCustomerNotificationCount] = useState(0);
  const [filingNotificationCount, setFilingNotificationCount] = useState(0);
  const [customerNotificationsWorkFlow, setCustomerNotificationsWorkFlow] = useState(0);
  const [totalNotificationCount, setTotalNotificationCount] = useState(0);
  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleNavItemClick = (section: string) => {
    let anchorElement: HTMLElement | null = null;
    if (section === 'View Details') anchorElement = viewDetailsRef.current;
    else if (section === 'Workflows') anchorElement = workflowsRef.current;
    else if (section === 'Configurations') anchorElement = configurationsRef.current;

    if (activeDropdown === section) {
      // Same section clicked - close dropdown
      setActiveDropdown(null);
      setDropdownAnchor(null);
    } else {
      // Different section clicked - ensure clean state transition
      setActiveDropdown(null);
      setDropdownAnchor(null);
      // Use setTimeout to ensure state is cleared before setting new dropdown
      setTimeout(() => {
        setActiveDropdown(section);
        setDropdownAnchor(anchorElement);
      }, 10);
    }
  };

  const handleDropdownClose = () => {
    setActiveDropdown(null);
    setDropdownAnchor(null);
  };


  const fetchNotifications = async () => {

    if (
      getAllNotificationCount
    ) {
      try {

        // custList = custList
        //   .filter(
        //     (item) =>
        //       item.notifiedUserId === authUser?.userId && !item.informationRead
        //   )
        //   .filter((item) => item.notificationType === "Notification");

        // // console.log("@@customerNotifications:", custList);
        // // setTotalNotificationCount((old) => old + custList.length);

        // setCustomerNotificationCount(custList.length);
        // let filingList = await getFilingNotifications();
        // filingList = filingList
        //   .filter(
        //     (item) =>
        //       item.notifiedUserId === authUser?.userId && !item.informationRead
        //   )
        //   .filter((item) => item.notificationType === "Notification");

        // // console.log("@@filingNotifications:", filingList);
        // // setTotalNotificationCount((old) => old + filingList.length);
        // setFilingNotificationCount(filingList.length);
        // let custListWorkflow = await getCustomerNotificationsWorkFlow();
        // custListWorkflow = custListWorkflow
        //   .filter(
        //     (item) =>
        //       item.notifiedUserId === authUser?.userId && !item.informationRead
        //   )
        //   .filter((item) => item.notificationType === "Notification");
        // // console.log("@@filingNotifications:", custListWorkflow);

        // setCustomerNotificationsWorkFlow(custListWorkflow.length);
        if (token) {
          const res = await getAllNotificationCount(token, authUser?.userId);
          setTotalNotificationCount(res.totalCount);
        }


      } catch (error) {
        console.error("@@Error:", error);
      }
    }
  };

  const handleNavigate = () => {
    navigate("/Notification");
  };

  useEffect(() => {
    setTotalNotificationCount(
      (prevTotal) => prevTotal + (notificationCount - prevTotal)
    );
  }, [notificationCount]);

  // useEffect(() => {
  //   if (authUser && authUser?.userId) {
  //     fetchNotifications()
  //     if (getAllNotificationCount) {
  //       const res = getAllNotificationCount()
  //       console.log("ALL NOTIFICATION COUNT", res);
  //     }
  //   };
  // }, [authUser]);

  useEffect(() => {

    // Log token
    if (token) {
      console.log("Token:", token);
      fetchNotifications()
    }

  }, [token]);
  const supportEmail = "mailto:Jsi-Velocity_support@jsitel.com";

  if (isPortalAuthenticated && !isBrandingLoaded) {
    return null;
  }

  return (
    <Fragment>
      <CustomDialog header="Error" visible={showAlert} onHide={closeAlert} footer={null}>
        {alertMessage}
      </CustomDialog>

      {/* Transparent Navbar Background */}
      <Box
        sx={{
          position: 'relative',
          top: 0,
          left: 0,
          right: 0,
          height: '88px',
          background: 'transparent',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {/* White Rounded Container */}
        <Box
          sx={{
            maxWidth: '1320px',
            width: 'calc(100% - 32px)',
            height: '56px',
            margin: '0 auto',
            backgroundColor: '#FFFFFF',
            borderRadius: '8px',
            padding: { xs: '0 12px', md: '0 16px', lg: '0 24px' },
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'nowrap',
            gap: { xs: 1, md: 1.5, lg: 2 },
            boxShadow: '0px 4px 12px rgba(0,0,0,0.08)',
          }}
        >
          {/* LEFT - Logo */}
          <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
            <Link to='/' style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', gap: '10px', flexShrink: 0 }}>
              <Box
                component="img"
                src={brandLogoSrc}
                alt='Logo'
                sx={{
                  maxHeight: '32px',
                  maxWidth: { xs: '100px', sm: '120px', md: '140px' },
                  width: 'auto',
                  height: 'auto',
                  objectFit: 'contain',
                  display: 'block',
                  flexShrink: 0,
                }}
              />
              <Box
                component="img"
                src={TrackNowLogo}
                alt="TrackNow"
                sx={{
                  maxHeight: '26px',
                  maxWidth: '120px',
                  width: 'auto',
                  height: 'auto',
                  objectFit: 'contain',
                  display: { xs: 'none', md: 'block' },
                  flexShrink: 0,
                }}
              />
            </Link>
          </Box>

          {/* CENTER - Navigation Items (Desktop) */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: { md: 2, lg: 3 }, flexShrink: 0, flexWrap: 'nowrap' }}>
            {isPortalAuthenticated && (
              <Fragment>
                <NavItem
                  ref={viewDetailsRef}
                  label="View Details"
                  icon="viewDetails"
                  isActive={activeDropdown === 'View Details'}
                  onClick={() => handleNavItemClick('View Details')}
                />
                <NavItem
                  ref={workflowsRef}
                  label="Workflows"
                  icon="workflows"
                  isActive={activeDropdown === 'Workflows'}
                  onClick={() => handleNavItemClick('Workflows')}
                />
                <NavItem
                  ref={configurationsRef}
                  label="Configurations"
                  icon="configurations"
                  isActive={activeDropdown === 'Configurations'}
                  onClick={() => handleNavItemClick('Configurations')}
                />
              </Fragment>
            )}
          </Box>

          {/* RIGHT - User Actions */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, md: 1, lg: 1.5 }, flexShrink: 0, flexWrap: 'nowrap' }}>
            {portalUser && isPortalAuthenticated ? (
              <Fragment>
                {/* User Info - Desktop */}
                <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 1, flexShrink: 0 }}>
                  <GoogleMaterialIcon name="person" size={22} style={{ color: primaryColor }} />
                  <Typography
                    sx={{
                      fontSize: '14px',
                      fontWeight: 500,
                      color: primaryColor,
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {`${portalUser.firstname} ${portalUser.lastname}`}
                  </Typography>
                </Box>

                {/* Notifications */}
                <IconButton
                  onClick={handleNavigate}
                  sx={{
                    color: primaryColor,
                    '&:hover': { backgroundColor: alpha(primaryColor, 0.08) },
                  }}
                >
                  <Badge badgeContent={totalNotificationCount} color="error">
                    <GoogleMaterialIcon name="notifications" size={24} style={{ color: primaryColor }} />
                  </Badge>
                </IconButton>

                {/* Support Button */}
                <Box sx={{ '& .MuiButton-root': { minWidth: 'auto', height: '32px', padding: '4px 8px' } }}>
                  <TrackNowButton
                    variant="tertiary"
                    onClick={() => window.open(supportEmail, '_blank')}
                  >
                    <GoogleMaterialIcon name="support_agent" size={16} />
                    <Typography sx={{ fontSize: '13px', display: { xs: 'none', lg: 'block' }, ml: 0.5 }}>
                      Support
                    </Typography>
                  </TrackNowButton>
                </Box>
                <Link
                  to="https://inteserra360.com/#/index"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    textDecoration: 'none',
                    gap: '8px',
                  }}
                >
                  <img src={JSI360} alt="Inteserra 360" style={{ height: '32px' }} />
                </Link>
                {/* Logout */}
                <IconButton
                  onClick={handleLogout}
                  sx={{
                    color: primaryColor,
                    '&:hover': { backgroundColor: alpha(primaryColor, 0.08) },
                  }}
                >
                  <GoogleMaterialIcon name="logout" size={24} style={{ color: primaryColor }} />
                </IconButton>
              </Fragment>
            ) : (
              <Fragment>
              </Fragment>
            )}

            {/* Mobile Menu */}

            <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
              <IconButton
                onClick={handleOpenNavMenu}
                sx={{
                  color: primaryColor,
                  '&:hover': { backgroundColor: alpha(primaryColor, 0.08) },
                }}
              >
                <GoogleMaterialIcon name="menu" size={24} style={{ color: primaryColor }} />
              </IconButton>

              <Menu
                anchorEl={anchorElNav}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{ mt: 1 }}
                PaperProps={{
                  sx: {
                    width: 280,
                    maxHeight: 420,
                    overflowY: "auto",
                  },
                }}
              >

                {/* VIEW DETAILS */}
                <MenuItem
                  onClick={() => setOpenViewDetails(!openViewDetails)}
                  sx={{ fontWeight: 600, display: "flex", justifyContent: "space-between" }}
                >
                  View Details
                  <GoogleMaterialIcon
                    name={openViewDetails ? "expand_less" : "expand_more"}
                    size={22}
                  />
                </MenuItem>

                {openViewDetails && (
                  <Box sx={{ pl: 3 }}>
                    <MenuItem disabled={!canViewHome} onClick={() => { navigate("/"); handleCloseNavMenu(); }}>
                      Home
                    </MenuItem>
                    {canShowTrackNowMasterList && (
                      <MenuItem disabled={!canViewTrackNowMasterList} onClick={() => { navigate("/filing-master-list"); handleCloseNavMenu(); }}>
                        TN Master Filing List
                      </MenuItem>
                    )}
                    {canShowTrackNowDeferredList && (
                      <MenuItem disabled={!canViewTrackNowDeferredList} onClick={() => { navigate("/add-filings"); handleCloseNavMenu(); }}>
                        TN Deferred Filings
                      </MenuItem>
                    )}
                    {canViewPostAwardMasterList && (
                      <MenuItem disabled={!canViewPostAwardMasterList} onClick={() => { navigate("/postaward-filing-master-list"); handleCloseNavMenu(); }}>
                        PA Master Filing List
                      </MenuItem>
                    )}
                    {canShowPostAwardDeferredList && (
                      <MenuItem disabled={!canViewPostAwardDeferredList} onClick={() => { navigate("/add-filing-postaward"); handleCloseNavMenu(); }}>
                        PA Award Deferred Filings
                      </MenuItem>
                    )}
                    <MenuItem disabled={!canViewClientTracker} onClick={() => { localStorage.removeItem("selectedCustomer"); setCurrentCustomer && setCurrentCustomer(null); navigate("/client-filing-tracker-list"); handleCloseNavMenu(); }}>
                      Client Tracker
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        handleNavigate();
                        handleCloseNavMenu();
                      }}
                    >
                      Notification
                    </MenuItem>
                  </Box>
                )}

                {/* WORKFLOWS */}
                <MenuItem
                  onClick={() => setOpenWorkflows(!openWorkflows)}
                  sx={{ fontWeight: 600, display: "flex", justifyContent: "space-between" }}
                >
                  Workflows
                  <GoogleMaterialIcon
                    name={openWorkflows ? "expand_less" : "expand_more"}
                    size={22}
                  />
                </MenuItem>

                {openWorkflows && (
                  <Box sx={{ pl: 3 }}>
                    <MenuItem
                      disabled={!canShowAddNewClient}
                      onClick={() => {
                        setCurrentCustomer && setCurrentCustomer(null);
                        navigate("/customer");
                        handleCloseNavMenu();
                      }}
                    >
                      Add New Client
                    </MenuItem>
                    {canShowAddTrackNowFiling && (
                      <MenuItem disabled={!canViewAddTrackNowFiling} onClick={() => { navigate("/filing-master"); handleCloseNavMenu(); }}>
                        Add New TN Filing
                      </MenuItem>
                    )}
                    {canShowTrackNowFilingMasterApproval && (
                      <MenuItem disabled={!canViewTrackNowFilingMasterApproval} onClick={() => { navigate("/filing-master-approval-list"); handleCloseNavMenu(); }}>
                        TN Filing Master Approval
                      </MenuItem>
                    )}
                    {canShowTrackNowClientFilingMasterApproval && (
                      <MenuItem disabled={!canViewTrackNowClientFilingMasterApproval} onClick={() => { navigate("/client-filing-master-approval-list"); handleCloseNavMenu(); }}>
                        TN Client Filing Master Approval
                      </MenuItem>
                    )}
                    {canShowAddPostAwardMaster && (
                      <MenuItem disabled={!canViewAddPostAwardMaster} onClick={() => { navigate("/postaward-master-form"); handleCloseNavMenu(); }}>
                        Add New PA Master
                      </MenuItem>
                    )}
                    {canShowPostAwardMasterApproval && (
                      <MenuItem disabled={!canViewPostAwardMasterApproval} onClick={() => { navigate("/postaward-approval-list"); handleCloseNavMenu(); }}>
                        PA Master Approval
                      </MenuItem>
                    )}
                    {canShowPostAwardClientApproval && (
                      <MenuItem disabled={!canViewPostAwardClientApproval} onClick={() => { navigate("/PostAwardClientfilingMasterApprovalList"); handleCloseNavMenu(); }}>
                        PA Client Records Master Approval
                      </MenuItem>
                    )}
                  </Box>
                )}

                {/* CONFIGURATION */}
                <MenuItem
                  onClick={() => setOpenConfigurations(!openConfigurations)}
                  sx={{ fontWeight: 600, display: "flex", justifyContent: "space-between" }}
                >
                  Configuration
                  <GoogleMaterialIcon
                    name={openConfigurations ? "expand_less" : "expand_more"}
                    size={22}
                  />
                </MenuItem>

                {openConfigurations && (
                  <Box sx={{ pl: 3 }}>
                    {canShowBusinessCategory && (
                      <MenuItem disabled={!canViewBusinessCategory} onClick={() => { navigate("/business-category"); handleCloseNavMenu(); }}>
                        TN Business Category
                      </MenuItem>
                    )}

                    {canShowApprovalConfiguration && (
                      <MenuItem disabled={!canViewApprovalConfiguration} onClick={() => { navigate("/ApprovalConfig"); handleCloseNavMenu(); }}>
                        TN Approval Configuration
                      </MenuItem>
                    )}

                    {canShowProgramNames && (
                      <MenuItem disabled={!canViewProgramNames} onClick={() => { navigate("/ProgramNames"); handleCloseNavMenu(); }}>
                        PA Program Configuration
                      </MenuItem>
                    )}

                    {canShowPostAwardApprovalConfiguration && (
                      <MenuItem disabled={!canViewPostAwardApprovalConfiguration} onClick={() => { navigate("/PostAwardApproverConfiguration"); handleCloseNavMenu(); }}>
                        PA Approval Configuration
                      </MenuItem>
                    )}

                    <MenuItem onClick={() => { navigate("/notificationConfiguration"); handleCloseNavMenu(); }}>
                      Notification Configuration
                    </MenuItem>

                    <MenuItem disabled={!canViewSetting} onClick={() => { navigate("/reminder"); handleCloseNavMenu(); }}>
                      Reminder Configuration
                    </MenuItem>

                    {showBrandingPage && (
                      <MenuItem onClick={() => { navigate("/branding-configuration"); handleCloseNavMenu(); }}>
                        Branding Configuration
                      </MenuItem>
                    )}

                    {(isAdmin || isAdminPostaward) && (
                      <MenuItem onClick={() => { navigate("/rollOverFilings"); handleCloseNavMenu(); }}>
                        Rollover Filings
                      </MenuItem>
                    )}

                    <MenuItem disabled={!canViewUserRole} onClick={() => { navigate("/user-role-setup"); handleCloseNavMenu(); }}>
                      User Role Setup
                    </MenuItem>
                  </Box>
                )}

                {/* LOGOUT */}
                <MenuItem
                  onClick={() => {
                    handleLogout();
                    handleCloseNavMenu();
                  }}
                >
                  Logout
                </MenuItem>

              </Menu>
            </Box>

          </Box>
        </Box>
      </Box>
      {/* Dropdown Area */}
      <NavDropdown
        isOpen={!!activeDropdown}
        onClose={handleDropdownClose}
        activeSection={activeDropdown || ''}
        anchorElement={dropdownAnchor}
      />
    </Fragment>
  );
}

export default NavBar;
